export enum PopularTypes {
  week = 'week',
  month = 'month',
  all = 'all',
}
